export const addEvaluationB = (evaluationB) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();
    
    if (
      !evaluationB.question ||
      !evaluationB.answers ||
      !evaluationB.selectedCriteria ||
      !evaluationB.selectedSchemes || 
      !evaluationB.createdBy ||
      !evaluationB.createdDate
    ) {
      dispatch({
        type: "ADDED_EVALUATION_B_ERROR",
        err: { message: "Input field required." },
      });
    } else {
      
      firestore
        .collection("evaluationB")
        .add({
          question: evaluationB.question,
          descriptions: evaluationB.descriptions,
          answers: evaluationB.answers,
          selectedCriteria: evaluationB.selectedCriteria,
          selectedSchemes: evaluationB.selectedSchemes,
          createdBy: evaluationB.createdBy,
          createdDate: evaluationB.createdDate,
        })
        .then((resp) => {
          dispatch({
            type: "ADDED_EVALUATION_B",
            message: "EvaluationB added successfully.",
            id: resp.id,
          });
        })
        .catch((err) => {
          dispatch({ type: "ADDED_EVALUATION_B_ERROR", err });
        });
    }
  };
};

export const updateEvaluationB = (updatedEvaluationB, evaluationBId) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();

    if (
      !updatedEvaluationB.question ||
      !updatedEvaluationB.answers ||
      !updatedEvaluationB.selectedCriteria ||
      !updatedEvaluationB.selectedSchemes || 
      !updatedEvaluationB.createdBy ||
      !updatedEvaluationB.createdDate
    ) {
      dispatch({
        type: "UPDATED_EVALUATION_B_ERROR",
        err: { message: "Input field required." },
      });
    } else {

      firestore
        .collection("evaluationB")
        .doc(evaluationBId)
        .update({
          question: updatedEvaluationB.question,
          descriptions: updatedEvaluationB.descriptions,
          answers: updatedEvaluationB.answers,
          selectedCriteria: updatedEvaluationB.selectedCriteria,
          selectedSchemes: updatedEvaluationB.selectedSchemes,
          createdBy: updatedEvaluationB.createdBy,
          createdDate: updatedEvaluationB.createdDate,
        })
        .then(() => {
          dispatch({
            type: "UPDATED_EVALUATION_B",
            message: "EvaluationB updated successfully.",
          });
        })
        .catch((err) => {
          dispatch({ type: "UPDATED_EVALUATION_B_ERROR", err });
        });
    }
  };
};

export const deleteEvaluationB = (evaluationBId) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();

    firestore
      .collection("evaluationB")
      .doc(evaluationBId)
      .delete()
      .then(() => {
        dispatch({
          type: "DELETED_EVALUATION_B",
          message: "EvaluationB deleted successfully.",
        });
      })
      .catch((err) => {
        dispatch({ type: "DELETED_EVALUATION_B_ERROR", err });
      });
  };
};